/*
 * @Author: 张印 hbzyin@163.com
 * @FilePath: /mall-fe/src/comps/BackTop.tsx
 * @Description: 回到页面顶部快捷操作组件
 *
 */
import { BackTop as BackTopAntd } from 'antd';
import IconTop from 'icons/top.svg';
import { ModalContext, SiteContext } from 'libs/contexts';
import { useContext } from 'react';

export default function BackTop() {
  const onModal = useContext(ModalContext);
  const site = useContext(SiteContext); // 站点配置信息

  return (
    <div>
      <BackTopAntd style={{ marginRight: onModal.width }} visibilityHeight={500}>
        <span className="icon">
          <IconTop />
        </span>
      </BackTopAntd>

      <style jsx>{`
        :global(.ant-back-top) {
          width: 48px;
          height: 48px;
          right: 24px;
          bottom: 140px;
          color: #bbb;
          text-align: center;
          cursor: pointer;
          z-index: 999;
          background: #fff;
          box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.08);
          border-radius: 1px;
          display: flex;
          align-items: center;
          justify-content: center;
          padding-top: 5px;
        }

        .icon {
          fill: #fff;
        }
        :global(.ant-back-top:hover) {
          background: ${site?.global?.platformMainColor};
        }
        :global(.ant-back-top:hover svg path) {
          fill: #fff;
        }
      `}</style>
    </div>
  );
}
